import { useState } from "react";
import { EditCompanies } from "./EditCompanies";
import { CreateCompany } from "../../pages/CreateCompany";

export const Companies = () => {
    // const [refetch, setRefetch] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const [highlightId, setHighlightId] = useState(null);

    const [showCreateCompany, setShowCreateCompany] = useState(false); // New state for offcanvas

    return (
        <div className="d-flex flex-column  w-100">
            {/* Pass show & setShow to CreateCompany (Offcanvas) */}
            <CreateCompany 
                setHighlightId = {setHighlightId}
                setReloadKey={setReloadKey}
                show={showCreateCompany}
                setShow={setShowCreateCompany}
            />

            {/* Pass setShow to EditCompanies (Button) */}
            <EditCompanies
                highlightId ={highlightId}
                reloadKey={reloadKey}
                setShowCreateCompany={setShowCreateCompany}
            />
        </div>
    );
};  